<template>
  <Transition
    enter-active-class="transform ease-out duration-300 transition"
    enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
    enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
    leave-active-class="transition ease-in duration-100"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-if="notificationStore.message && show"
      class="fixed top-6 right-6 z-[9999]"
    >
      <div
        class="rounded-xl shadow-2xl p-6 max-w-md w-full bg-white border-l-4 backdrop-blur-sm"
        :class="{
          'border-green-500': notificationStore.type === 'success',
          'border-red-500': notificationStore.type === 'error',
          'border-yellow-500': notificationStore.type === 'warning',
        }"
      >
        <div class="flex items-start space-x-4">
          <div class="flex-shrink-0 mt-1">
            <svg
              v-if="notificationStore.type === 'success'"
              class="h-6 w-6 text-green-500"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <svg
              v-else-if="notificationStore.type === 'error'"
              class="h-6 w-6 text-red-500"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <svg
              v-else
              class="h-6 w-6 text-yellow-500"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <div class="flex-1 min-w-0">
            <p
              class="text-base font-['Roboto_Medium'] text-gray-900 leading-tight"
            >
              {{
                notificationStore.type === "success"
                  ? "Succès"
                  : notificationStore.type === "error"
                    ? "Erreur"
                    : "Alerte"
              }}
            </p>
            <p
              class="mt-2 text-sm font-['Roboto_Regular'] text-gray-600 leading-relaxed"
            >
              {{ notificationStore.message }}
            </p>
          </div>
          <div class="flex-shrink-0 ml-4">
            <button
              class="inline-flex text-gray-400 hover:text-gray-500 focus:outline-none transition-colors duration-200"
              @click="close"
            >
              <span class="sr-only">Fermer</span>
              <svg
                class="h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref } from "@vue/runtime-core";
import { useNotificationStore } from "@/stores/ui/notification";

const notificationStore = useNotificationStore();
const show = ref(true);

const close = () => {
  show.value = false;
};
</script>

<script lang="ts">
export default {
  name: "Notification",
};
</script>
